// extracted by mini-css-extract-plugin
export default {"form":"AdminCreateNoticias_form__cAXzK","input":"AdminCreateNoticias_input__BRxQk","textarea":"AdminCreateNoticias_textarea__Hjx6r","button":"AdminCreateNoticias_button__RHilK"};